// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ul, li {
  list-style: none;
  padding: 0;
  margin: 0;
  outline: 0;
}

nav {
  color: #929394;
  width: 230px;
  background: white;
  overflow: visible;
  font-size: 14px;
  transition: transform 0.3s ease-out, width 0.3s ease-out;
  height: 100%;
  overflow-y: hidden;
  position: relative;
  z-index: 1020;
  box-shadow: 0 0 3px rgba(31, 50, 77, 0.2);
}

.menu-items {
  height: calc(100vh - 85px);
  overflow-y: hidden;
  overflow-x: hidden;
}
.menu-items::-webkit-scrollbar {
  width: 10px;
  height: 5px;
}
.menu-items::-webkit-scrollbar-button:start:decrement, .menu-items::-webkit-scrollbar-button:end:increment {
  height: 0;
  display: block;
  background-color: transparent;
}
.menu-items::-webkit-scrollbar-button:horizontal:start:decrement, .menu-items::-webkit-scrollbar-button:horizontal:end:increment {
  height: 0;
  display: block;
  background-color: transparent;
}
.menu-items::-webkit-scrollbar-track-piece {
  background-color: #293238;
}
.menu-items::-webkit-scrollbar-thumb:vertical, .menu-items::-webkit-scrollbar-thumb:horizontal {
  background-color: #bbb;
}
.menu-items:hover {
  overflow-y: auto;
}
.menu-items > ul {
  padding-bottom: 20px;
}

header {
  border-bottom: 2px solid #ebeff2;
  padding: 5px 5px 8px 5px;
  transition: padding ease-out 0.3s;
  height: 35px;
  overflow: hidden;
}
header a.toggle-menu-collapse {
  position: relative;
  transition: left 0.3s ease-out, right 0.3s ease-out;
  outline: none;
}
header a.toggle-menu-collapse .icon {
  font-size: 18px;
  line-height: 18px;
  color: #93a4aa;
}
header a.toggle-menu-collapse .icon:hover {
  color: #007cbe;
  cursor: pointer;
}

a.menu-item {
  display: flex;
  cursor: pointer;
  margin: 0;
  color: rgba(45, 74, 89, 0.75);
  padding-top: 0px;
  padding-bottom: 0px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: white;
  height: 60px;
  position: relative;
  font-size: 14px;
  justify-content: left;
  align-items: center;
  font-weight: 600;
}
a.menu-item .menu-item-icon {
  height: 40px;
  width: 40px;
  min-width: 40px;
  border-radius: 50%;
  padding-top: 9px;
  padding-left: 11px;
  font-size: 20px;
  margin: 10px 0;
  color: rgb(0, 167, 234);
}
a.menu-item .menu-item-icon:hover {
  cursor: pointer;
}
a.menu-item .menu-item-title {
  cursor: pointer;
  padding-top: 10px;
  padding-bottom: 10px;
  display: block;
  height: 41px;
  width: 156px;
  text-overflow: ellipsis;
  overflow: hidden;
}
a.menu-item .menu-item-title:hover {
  cursor: pointer;
}
a.menu-item .menu-item-expand {
  animation-duration: 0.5s;
  fill: #929394;
  height: 9px;
  width: 12px;
  margin: 14px 0 0 0;
  transition: all 0.3s ease-in-out 0s;
  cursor: pointer;
  position: absolute;
  top: 0;
}
a.menu-item .menu-item-expand.expanded {
  transition: all 0.3s ease-in-out 0s;
  transform: rotate(180deg);
}

nav > ul > li:hover .menu-item,
.menu-item:hover,
a.menu-item:not([href]):not([tabindex]):hover,
.menu-item.active-item {
  cursor: pointer;
  text-decoration: none;
}
nav > ul > li:hover .menu-item .menu-item-icon,
.menu-item:hover .menu-item-icon,
a.menu-item:not([href]):not([tabindex]):hover .menu-item-icon,
.menu-item.active-item .menu-item-icon {
  cursor: pointer;
  opacity: 1;
}
nav > ul > li:hover .menu-item .menu-item-expand,
.menu-item:hover .menu-item-expand,
a.menu-item:not([href]):not([tabindex]):hover .menu-item-expand,
.menu-item.active-item .menu-item-expand {
  cursor: pointer;
  fill: #FFF;
}
nav > ul > li:hover .menu-item .menu-item-expand:hover,
.menu-item:hover .menu-item-expand:hover,
a.menu-item:not([href]):not([tabindex]):hover .menu-item-expand:hover,
.menu-item.active-item .menu-item-expand:hover {
  cursor: pointer;
}

.sub-menu {
  padding: 0;
  background-color: #182127;
  max-height: 0;
  transition: max-height 0.3s ease-out;
  overflow: hidden;
}
.sub-menu li:first-child {
  padding-top: 10px;
}
.sub-menu li:last-child {
  padding-bottom: 10px;
}
.sub-menu.expanded {
  max-height: 500px;
  transition: max-height 0.3s ease-in;
}

a:hover {
  background-color: #f2f5f7;
}

a.active-item {
  background-color: #f2f5f7;
  color: #0a2533;
}

a.active-item .menu-item-icon {
  background: #00a7ea;
  color: white;
}

a.sub-menu-item {
  cursor: pointer;
  display: block;
  margin: 0;
  color: #929394;
  padding-top: 10px;
  padding-bottom: 10px;
  max-width: 207px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
a.sub-menu-item:hover {
  cursor: pointer;
  color: white;
}
a.sub-menu-item.active-sub-item, a.sub-menu-item.active-sub-item:hover {
  color: #f2f5f7;
}

nav.menu-collapsed {
  transform: translate(0, 0);
  width: 64px;
  transition: transform 0.3s ease-out, width 0.3s ease-out;
}
nav.menu-collapsed .menu-items {
  overflow-y: hidden;
}
nav.menu-collapsed .sub-menu,
nav.menu-collapsed .menu-item-title,
nav.menu-collapsed .menu-item-expand {
  display: none;
}
nav.menu-collapsed:hover, nav.menu-collapsed.in-focus {
  width: 230px;
}
nav.menu-collapsed:hover .menu-items:hover, nav.menu-collapsed.in-focus .menu-items:hover {
  overflow-y: auto;
}
nav.menu-collapsed:hover .sub-menu,
nav.menu-collapsed:hover .menu-item-title,
nav.menu-collapsed:hover .menu-item-expand, nav.menu-collapsed.in-focus .sub-menu,
nav.menu-collapsed.in-focus .menu-item-title,
nav.menu-collapsed.in-focus .menu-item-expand {
  display: block;
}
nav.menu-collapsed:hover.route-triggered, nav.menu-collapsed.in-focus.route-triggered {
  width: 60px;
}
nav.menu-collapsed:hover.route-triggered .menu-items, nav.menu-collapsed.in-focus.route-triggered .menu-items {
  overflow-y: hidden;
}
nav.menu-collapsed:hover.route-triggered .sub-menu,
nav.menu-collapsed:hover.route-triggered .menu-item-title,
nav.menu-collapsed:hover.route-triggered .menu-item-expand, nav.menu-collapsed.in-focus.route-triggered .sub-menu,
nav.menu-collapsed.in-focus.route-triggered .menu-item-title,
nav.menu-collapsed.in-focus.route-triggered .menu-item-expand {
  display: none;
}

/**
 *  The following items need different styles
 *  if the language is right-to-left (rtl)
 */
::ng-deep body {
  /* a.menu-item */
  /* a.toggle-menu-collapse */
  /* a.menu-item .menu-item-icon */
  /* a.menu-item .menu-item-title */
  /* a.menu-item .menu-item-expand */
  /* a.sub-menu-item */
}
::ng-deep body app-side-nav a.menu-item {
  padding-right: 10px;
  padding-left: 10px;
}
::ng-deep body.rtl app-side-nav a.menu-item {
  padding-right: 20px;
  padding-left: 10px;
}
::ng-deep body app-side-nav a.toggle-menu-collapse {
  left: 196px;
}
::ng-deep body app-side-nav a.toggle-menu-collapse img {
  transform: rotate(0deg);
}
::ng-deep body.rtl app-side-nav a.toggle-menu-collapse {
  left: auto;
  right: 196px;
}
::ng-deep body.rtl app-side-nav a.toggle-menu-collapse .icon {
  transform: rotate(180deg);
}
::ng-deep body app-side-nav nav.menu-collapsed header a.toggle-menu-collapse {
  left: 15px;
  right: auto;
}
::ng-deep body app-side-nav nav.menu-collapsed header a.toggle-menu-collapse .icon {
  transform: rotate(180deg);
}
::ng-deep body.rtl app-side-nav nav.menu-collapsed header a.toggle-menu-collapse {
  left: auto;
  right: 15px;
}
::ng-deep body.rtl app-side-nav nav.menu-collapsed header a.toggle-menu-collapse .icon {
  transform: rotate(0deg);
}
::ng-deep body app-side-nav a.menu-item .menu-item-icon {
  float: left;
}
::ng-deep body.rtl app-side-nav a.menu-item .menu-item-icon {
  float: right;
}
::ng-deep body app-side-nav a.menu-item .menu-item-title {
  padding-right: 0px;
  padding-left: 10px;
  float: left;
}
::ng-deep body.rtl app-side-nav a.menu-item .menu-item-title {
  padding-right: 10px;
  padding-left: 0px;
  float: right;
}
::ng-deep body app-side-nav a.menu-item .menu-item-expand {
  left: 196px;
  right: auto;
}
::ng-deep body.rtl app-side-nav a.menu-item .menu-item-expand {
  left: auto;
  right: 196px;
}
::ng-deep body app-side-nav a.sub-menu-item {
  padding-right: 0px;
  padding-left: 50px;
}
::ng-deep body.rtl app-side-nav a.sub-menu-item {
  padding-right: 50px;
  padding-left: 0px;
}

.menu-items:focus {
  outline: none;
}

.menu-items > ul > li > a {
  border: 1px dotted transparent;
}

.keyboard-triggered .menu-items:focus > ul > li[aria-selected=true] > a {
  border: 1px dotted white;
}

.keyboard-triggered .menu-items:focus li li[aria-selected=true] span {
  outline: 1px dotted white;
}`, "",{"version":3,"sources":["webpack://./src/app/components/side-nav/side-nav.component.scss","webpack://./../PSR%20ESP%20WebApp%20Build/src/app/components/side-nav/side-nav.component.scss"],"names":[],"mappings":"AAIA;EACE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;ACHF;;ADMA;EACE,cAZe;EAaf,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,wDAAA;EACA,YAAA;EAEA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,yCAAA;ACJF;;ADOA;EACE,0BAAA;EACA,kBAAA;EACA,kBAAA;ACJF;ADME;EACE,WAAA;EACA,WAAA;ACJJ;ADME;EAEI,SAAA;EACA,cAAA;EACA,6BAAA;ACLN;ADOE;EAEI,SAAA;EACA,cAAA;EACA,6BAAA;ACNN;ADQE;EACI,yBAAA;ACNN;ADQE;EAEI,sBAAA;ACPN;ADUE;EACE,gBAAA;ACRJ;ADWE;EACE,oBAAA;ACTJ;;ADaA;EACE,gCAAA;EAEA,wBAAA;EACA,iCAAA;EACA,YAAA;EACA,gBAAA;ACXF;ADaE;EACE,kBAAA;EACA,mDAAA;EACA,aAAA;ACXJ;ADYI;EACE,eAAA;EACA,iBAAA;EACA,cAAA;ACVN;ADWM;EACE,cAAA;EACA,eAAA;ACTR;;ADeA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,6BAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;ACZF;ADcE;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EAEA,uBAAA;ACbJ;ADcI;EACE,eAAA;ACZN;ADeE;EACE,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;ACbJ;ADcI;EACE,eAAA;ACZN;ADeE;EACE,wBAAA;EACA,aAxIa;EAyIb,WAAA;EACA,WAAA;EACA,kBAAA;EACA,mCAAA;EACA,eAAA;EACA,kBAAA;EACA,MAAA;ACbJ;ADcI;EACE,mCAAA;EACA,yBAAA;ACZN;;ADgBA;;;;EAIE,eAAA;EACA,qBAAA;ACbF;ADcE;;;;EACE,eAAA;EACA,UAAA;ACTJ;ADWE;;;;EACE,eAAA;EACA,UAAA;ACNJ;ADOI;;;;EACE,eAAA;ACFN;;ADMA;EACE,UAAA;EACA,yBAzKoB;EA0KpB,aAAA;EACA,oCAAA;EACA,gBAAA;ACHF;ADKE;EACE,iBAAA;ACHJ;ADKE;EACE,oBAAA;ACHJ;ADME;EACE,iBAAA;EACA,mCAAA;ACJJ;;ADQA;EACE,yBA3LiB;ACsLnB;;ADOA;EACE,yBA9LiB;EA+LjB,cAAA;ACJF;;ADOA;EACE,mBAAA;EACA,YAAA;ACJF;;ADQA;EACE,eAAA;EACA,cAAA;EACA,SAAA;EACA,cA9Me;EA+Mf,iBAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;ACLF;ADOE;EACE,eAAA;EACA,YAAA;ACLJ;ADQE;EAEE,cA3Ne;ACoNnB;;ADWA;EACE,0BAAA;EACA,WAAA;EACA,wDAAA;ACRF;ADUE;EACE,kBAAA;ACRJ;ADWE;;;EAGE,aAAA;ACTJ;ADYE;EACE,YAAA;ACVJ;ADYI;EACE,gBAAA;ACVN;ADaI;;;;;EAGE,cAAA;ACTN;ADYI;EACE,WAAA;ACVN;ADYM;EACE,kBAAA;ACVR;ADaM;;;;;EAGE,aAAA;ACTR;;ADiBA;;;EAAA;AAKA;EAEE,gBAAA;EAUA,2BAAA;EA6BA,gCAAA;EAQA,iCAAA;EAYA,kCAAA;EAUA,oBAAA;AChFF;ADYE;EACE,mBAAA;EACA,kBAAA;ACVJ;ADYE;EACE,mBAAA;EACA,kBAAA;ACVJ;ADcE;EACE,WAAA;ACZJ;ADaI;EACE,uBAAA;ACXN;ADcE;EACE,UAAA;EACA,YAAA;ACZJ;ADaI;EACE,yBAAA;ACXN;ADcE;EACE,UAAA;EACA,WAAA;ACZJ;ADaI;EACE,yBAAA;ACXN;ADcE;EACE,UAAA;EACA,WAAA;ACZJ;ADaI;EACE,uBAAA;ACXN;ADgBE;EACE,WAAA;ACdJ;ADgBE;EACE,YAAA;ACdJ;ADkBE;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;AChBJ;ADkBE;EACE,mBAAA;EACA,iBAAA;EACA,YAAA;AChBJ;ADoBE;EACE,WAAA;EACA,WAAA;AClBJ;ADoBE;EACE,UAAA;EACA,YAAA;AClBJ;ADsBE;EACE,kBAAA;EACA,kBAAA;ACpBJ;ADsBE;EACE,mBAAA;EACA,iBAAA;ACpBJ;;ADyBA;EAAmB,aAAA;ACrBnB;;ADsBA;EACE,8BAAA;ACnBF;;ADqBA;EACE,wBAAA;AClBF;;ADoBA;EACE,yBAAA;ACjBF","sourcesContent":["$side-nav-color: #929394;\n$sub-menu-background: #182127;\n$active-menu-item: #f2f5f7;\n\nul, li {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  outline: 0;\n}\n\nnav {\n  color: $side-nav-color;\n  width: 230px;\n  background: white;\n  overflow: visible;\n  font-size: 14px;\n  transition: transform 0.3s ease-out, width 0.3s ease-out;\n  height: 100%;\n  //padding-top: 50px;\n  overflow-y: hidden;\n  position: relative;\n  z-index: 1020;\n  box-shadow: 0 0 3px rgba(31,50,77,.2);\n}\n\n.menu-items {\n  height: calc(100vh - 85px);\n  overflow-y: hidden;\n  overflow-x: hidden;\n\n  &::-webkit-scrollbar {\n    width: 10px;\n    height: 5px\n  }\n  &::-webkit-scrollbar-button:start:decrement,\n  &::-webkit-scrollbar-button:end:increment {\n      height: 0;\n      display: block;\n      background-color: transparent\n  }\n  &::-webkit-scrollbar-button:horizontal:start:decrement,\n  &::-webkit-scrollbar-button:horizontal:end:increment {\n      height: 0;\n      display: block;\n      background-color: transparent\n  }\n  &::-webkit-scrollbar-track-piece {\n      background-color: #293238;\n  }\n  &::-webkit-scrollbar-thumb:vertical,\n  &::-webkit-scrollbar-thumb:horizontal {\n      background-color: #bbb\n  }\n\n  &:hover {\n    overflow-y: auto;\n  }\n\n  & > ul {\n    padding-bottom: 20px;\n  }\n}\n\nheader {\n  border-bottom: 2px solid #ebeff2;\n\n  padding: 5px 5px 8px 5px;\n  transition: padding ease-out .3s;\n  height: 35px;\n  overflow: hidden;\n\n  a.toggle-menu-collapse {\n    position: relative;\n    transition: left 0.3s ease-out, right 0.3s ease-out;\n    outline: none;\n    .icon {\n      font-size: 18px;\n      line-height: 18px;\n      color:#93a4aa;\n      &:hover {\n        color: #007cbe;\n        cursor: pointer;\n      }\n    }\n  }\n}\n\na.menu-item {\n  display: flex;\n  cursor: pointer;\n  margin: 0;\n  color: rgba(45, 74, 89, 0.75);\n  padding-top: 0px;\n  padding-bottom: 0px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  background-color: white;\n  height: 60px;\n  position: relative;\n  font-size: 14px;\n  justify-content: left;\n  align-items: center;\n  font-weight: 600;\n\n  .menu-item-icon {\n    height: 40px;\n    width: 40px;\n    min-width: 40px;\n    border-radius: 50%;\n    padding-top: 9px;\n    padding-left: 11px;\n    font-size: 20px;\n    margin: 10px 0;\n\n    color:rgb(0, 167, 234);\n    &:hover {\n      cursor: pointer;\n    }\n  }\n  .menu-item-title {\n    cursor: pointer;\n    padding-top: 10px;\n    padding-bottom: 10px;\n    display: block;\n    height: 41px;\n    width: 156px;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    &:hover {\n      cursor: pointer;\n    }\n  }\n  .menu-item-expand {\n    animation-duration: .5s;\n    fill: $side-nav-color;\n    height: 9px;\n    width: 12px;\n    margin: 14px 0 0 0;\n    transition: all 0.3s ease-in-out 0s;\n    cursor: pointer;\n    position: absolute;\n    top: 0;\n    &.expanded {\n      transition: all 0.3s ease-in-out 0s;\n      transform: rotate(180deg);\n    }\n  }\n}\nnav > ul > li:hover .menu-item,\n.menu-item:hover,\na.menu-item:not([href]):not([tabindex]):hover,\n.menu-item.active-item {\n  cursor: pointer;\n  text-decoration: none;\n  .menu-item-icon {\n    cursor: pointer;\n    opacity: 1;\n  }\n  .menu-item-expand {\n    cursor: pointer;\n    fill: #FFF;\n    &:hover {\n      cursor: pointer;\n    }\n  }\n}\n.sub-menu {\n  padding: 0;\n  background-color: $sub-menu-background;\n  max-height: 0;\n  transition: max-height 0.3s ease-out;\n  overflow: hidden;\n\n  li:first-child {\n    padding-top: 10px;\n  }\n  li:last-child {\n    padding-bottom: 10px;\n  }\n\n  &.expanded {\n    max-height: 500px;\n    transition: max-height 0.3s ease-in;\n  }\n}\n\na:hover {\n  background-color: $active-menu-item;\n}\na.active-item {\n  background-color: $active-menu-item;\n  color:#0a2533;\n}\n\na.active-item .menu-item-icon{\n  background: #00a7ea;\n  color: white;\n\n}\n\na.sub-menu-item {\n  cursor: pointer;\n  display: block;\n  margin: 0;\n  color: $side-nav-color;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  max-width: 207px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  &:hover {\n    cursor: pointer;\n    color: white;\n  }\n\n  &.active-sub-item,\n  &.active-sub-item:hover {\n    color: $active-menu-item;\n  }\n}\n\nnav.menu-collapsed {\n  transform: translate(0,0);\n  width: 64px;\n  transition: transform 0.3s ease-out, width 0.3s ease-out;\n\n  .menu-items {\n    overflow-y: hidden;\n  }\n\n  .sub-menu,\n  .menu-item-title,\n  .menu-item-expand {\n    display: none;\n  }\n\n  &:hover, &.in-focus {\n    width: 230px;\n\n    .menu-items:hover {\n      overflow-y: auto;\n    }\n\n    .sub-menu,\n    .menu-item-title,\n    .menu-item-expand {\n      display: block;\n    }\n\n    &.route-triggered {\n      width: 60px;\n\n      .menu-items {\n        overflow-y: hidden;\n      }\n\n      .sub-menu,\n      .menu-item-title,\n      .menu-item-expand {\n        display: none;\n      }\n    }\n\n  }\n}\n\n\n/**\n *  The following items need different styles\n *  if the language is right-to-left (rtl)\n */\n\n::ng-deep body {\n\n  /* a.menu-item */\n  app-side-nav a.menu-item {\n    padding-right: 10px;\n    padding-left: 10px;\n  }\n  &.rtl app-side-nav a.menu-item {\n    padding-right: 20px;\n    padding-left: 10px;\n  }\n\n  /* a.toggle-menu-collapse */\n  app-side-nav a.toggle-menu-collapse {\n    left: 196px;\n    img {\n      transform: rotate(0deg);\n    }\n  }\n  &.rtl app-side-nav a.toggle-menu-collapse {\n    left: auto;\n    right: 196px;\n    .icon {\n      transform: rotate(180deg);\n    }\n  }\n  app-side-nav nav.menu-collapsed header a.toggle-menu-collapse {\n    left: 15px;\n    right: auto;\n    .icon {\n      transform: rotate(180deg);\n    }\n  }\n  &.rtl app-side-nav nav.menu-collapsed header a.toggle-menu-collapse {\n    left: auto;\n    right: 15px;\n    .icon {\n      transform: rotate(0deg);\n    }\n  }\n\n  /* a.menu-item .menu-item-icon */\n  app-side-nav a.menu-item .menu-item-icon {\n    float: left;\n  }\n  &.rtl app-side-nav a.menu-item .menu-item-icon {\n    float: right;\n  }\n\n  /* a.menu-item .menu-item-title */\n  app-side-nav a.menu-item .menu-item-title {\n    padding-right: 0px;\n    padding-left: 10px;\n    float: left;\n  }\n  &.rtl app-side-nav a.menu-item .menu-item-title {\n    padding-right: 10px;\n    padding-left: 0px;\n    float: right;\n  }\n\n  /* a.menu-item .menu-item-expand */\n  app-side-nav a.menu-item .menu-item-expand {\n    left: 196px;\n    right: auto;\n  }\n  &.rtl app-side-nav a.menu-item .menu-item-expand {\n    left: auto;\n    right: 196px;\n  }\n\n  /* a.sub-menu-item */\n  app-side-nav a.sub-menu-item {\n    padding-right: 0px;\n    padding-left: 50px;\n  }\n  &.rtl app-side-nav a.sub-menu-item {\n    padding-right: 50px;\n    padding-left: 0px;\n  }\n\n}\n\n.menu-items:focus {outline: none;}\n.menu-items > ul > li > a {\n  border: 1px dotted transparent;\n}\n.keyboard-triggered .menu-items:focus > ul > li[aria-selected=\"true\"] > a {\n  border: 1px dotted white;\n}\n.keyboard-triggered .menu-items:focus li li[aria-selected=\"true\"] span {\n  outline: 1px dotted white;\n}\n","ul, li {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  outline: 0;\n}\n\nnav {\n  color: #929394;\n  width: 230px;\n  background: white;\n  overflow: visible;\n  font-size: 14px;\n  transition: transform 0.3s ease-out, width 0.3s ease-out;\n  height: 100%;\n  overflow-y: hidden;\n  position: relative;\n  z-index: 1020;\n  box-shadow: 0 0 3px rgba(31, 50, 77, 0.2);\n}\n\n.menu-items {\n  height: calc(100vh - 85px);\n  overflow-y: hidden;\n  overflow-x: hidden;\n}\n.menu-items::-webkit-scrollbar {\n  width: 10px;\n  height: 5px;\n}\n.menu-items::-webkit-scrollbar-button:start:decrement, .menu-items::-webkit-scrollbar-button:end:increment {\n  height: 0;\n  display: block;\n  background-color: transparent;\n}\n.menu-items::-webkit-scrollbar-button:horizontal:start:decrement, .menu-items::-webkit-scrollbar-button:horizontal:end:increment {\n  height: 0;\n  display: block;\n  background-color: transparent;\n}\n.menu-items::-webkit-scrollbar-track-piece {\n  background-color: #293238;\n}\n.menu-items::-webkit-scrollbar-thumb:vertical, .menu-items::-webkit-scrollbar-thumb:horizontal {\n  background-color: #bbb;\n}\n.menu-items:hover {\n  overflow-y: auto;\n}\n.menu-items > ul {\n  padding-bottom: 20px;\n}\n\nheader {\n  border-bottom: 2px solid #ebeff2;\n  padding: 5px 5px 8px 5px;\n  transition: padding ease-out 0.3s;\n  height: 35px;\n  overflow: hidden;\n}\nheader a.toggle-menu-collapse {\n  position: relative;\n  transition: left 0.3s ease-out, right 0.3s ease-out;\n  outline: none;\n}\nheader a.toggle-menu-collapse .icon {\n  font-size: 18px;\n  line-height: 18px;\n  color: #93a4aa;\n}\nheader a.toggle-menu-collapse .icon:hover {\n  color: #007cbe;\n  cursor: pointer;\n}\n\na.menu-item {\n  display: flex;\n  cursor: pointer;\n  margin: 0;\n  color: rgba(45, 74, 89, 0.75);\n  padding-top: 0px;\n  padding-bottom: 0px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  background-color: white;\n  height: 60px;\n  position: relative;\n  font-size: 14px;\n  justify-content: left;\n  align-items: center;\n  font-weight: 600;\n}\na.menu-item .menu-item-icon {\n  height: 40px;\n  width: 40px;\n  min-width: 40px;\n  border-radius: 50%;\n  padding-top: 9px;\n  padding-left: 11px;\n  font-size: 20px;\n  margin: 10px 0;\n  color: rgb(0, 167, 234);\n}\na.menu-item .menu-item-icon:hover {\n  cursor: pointer;\n}\na.menu-item .menu-item-title {\n  cursor: pointer;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  display: block;\n  height: 41px;\n  width: 156px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\na.menu-item .menu-item-title:hover {\n  cursor: pointer;\n}\na.menu-item .menu-item-expand {\n  animation-duration: 0.5s;\n  fill: #929394;\n  height: 9px;\n  width: 12px;\n  margin: 14px 0 0 0;\n  transition: all 0.3s ease-in-out 0s;\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n}\na.menu-item .menu-item-expand.expanded {\n  transition: all 0.3s ease-in-out 0s;\n  transform: rotate(180deg);\n}\n\nnav > ul > li:hover .menu-item,\n.menu-item:hover,\na.menu-item:not([href]):not([tabindex]):hover,\n.menu-item.active-item {\n  cursor: pointer;\n  text-decoration: none;\n}\nnav > ul > li:hover .menu-item .menu-item-icon,\n.menu-item:hover .menu-item-icon,\na.menu-item:not([href]):not([tabindex]):hover .menu-item-icon,\n.menu-item.active-item .menu-item-icon {\n  cursor: pointer;\n  opacity: 1;\n}\nnav > ul > li:hover .menu-item .menu-item-expand,\n.menu-item:hover .menu-item-expand,\na.menu-item:not([href]):not([tabindex]):hover .menu-item-expand,\n.menu-item.active-item .menu-item-expand {\n  cursor: pointer;\n  fill: #FFF;\n}\nnav > ul > li:hover .menu-item .menu-item-expand:hover,\n.menu-item:hover .menu-item-expand:hover,\na.menu-item:not([href]):not([tabindex]):hover .menu-item-expand:hover,\n.menu-item.active-item .menu-item-expand:hover {\n  cursor: pointer;\n}\n\n.sub-menu {\n  padding: 0;\n  background-color: #182127;\n  max-height: 0;\n  transition: max-height 0.3s ease-out;\n  overflow: hidden;\n}\n.sub-menu li:first-child {\n  padding-top: 10px;\n}\n.sub-menu li:last-child {\n  padding-bottom: 10px;\n}\n.sub-menu.expanded {\n  max-height: 500px;\n  transition: max-height 0.3s ease-in;\n}\n\na:hover {\n  background-color: #f2f5f7;\n}\n\na.active-item {\n  background-color: #f2f5f7;\n  color: #0a2533;\n}\n\na.active-item .menu-item-icon {\n  background: #00a7ea;\n  color: white;\n}\n\na.sub-menu-item {\n  cursor: pointer;\n  display: block;\n  margin: 0;\n  color: #929394;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  max-width: 207px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\na.sub-menu-item:hover {\n  cursor: pointer;\n  color: white;\n}\na.sub-menu-item.active-sub-item, a.sub-menu-item.active-sub-item:hover {\n  color: #f2f5f7;\n}\n\nnav.menu-collapsed {\n  transform: translate(0, 0);\n  width: 64px;\n  transition: transform 0.3s ease-out, width 0.3s ease-out;\n}\nnav.menu-collapsed .menu-items {\n  overflow-y: hidden;\n}\nnav.menu-collapsed .sub-menu,\nnav.menu-collapsed .menu-item-title,\nnav.menu-collapsed .menu-item-expand {\n  display: none;\n}\nnav.menu-collapsed:hover, nav.menu-collapsed.in-focus {\n  width: 230px;\n}\nnav.menu-collapsed:hover .menu-items:hover, nav.menu-collapsed.in-focus .menu-items:hover {\n  overflow-y: auto;\n}\nnav.menu-collapsed:hover .sub-menu,\nnav.menu-collapsed:hover .menu-item-title,\nnav.menu-collapsed:hover .menu-item-expand, nav.menu-collapsed.in-focus .sub-menu,\nnav.menu-collapsed.in-focus .menu-item-title,\nnav.menu-collapsed.in-focus .menu-item-expand {\n  display: block;\n}\nnav.menu-collapsed:hover.route-triggered, nav.menu-collapsed.in-focus.route-triggered {\n  width: 60px;\n}\nnav.menu-collapsed:hover.route-triggered .menu-items, nav.menu-collapsed.in-focus.route-triggered .menu-items {\n  overflow-y: hidden;\n}\nnav.menu-collapsed:hover.route-triggered .sub-menu,\nnav.menu-collapsed:hover.route-triggered .menu-item-title,\nnav.menu-collapsed:hover.route-triggered .menu-item-expand, nav.menu-collapsed.in-focus.route-triggered .sub-menu,\nnav.menu-collapsed.in-focus.route-triggered .menu-item-title,\nnav.menu-collapsed.in-focus.route-triggered .menu-item-expand {\n  display: none;\n}\n\n/**\n *  The following items need different styles\n *  if the language is right-to-left (rtl)\n */\n::ng-deep body {\n  /* a.menu-item */\n  /* a.toggle-menu-collapse */\n  /* a.menu-item .menu-item-icon */\n  /* a.menu-item .menu-item-title */\n  /* a.menu-item .menu-item-expand */\n  /* a.sub-menu-item */\n}\n::ng-deep body app-side-nav a.menu-item {\n  padding-right: 10px;\n  padding-left: 10px;\n}\n::ng-deep body.rtl app-side-nav a.menu-item {\n  padding-right: 20px;\n  padding-left: 10px;\n}\n::ng-deep body app-side-nav a.toggle-menu-collapse {\n  left: 196px;\n}\n::ng-deep body app-side-nav a.toggle-menu-collapse img {\n  transform: rotate(0deg);\n}\n::ng-deep body.rtl app-side-nav a.toggle-menu-collapse {\n  left: auto;\n  right: 196px;\n}\n::ng-deep body.rtl app-side-nav a.toggle-menu-collapse .icon {\n  transform: rotate(180deg);\n}\n::ng-deep body app-side-nav nav.menu-collapsed header a.toggle-menu-collapse {\n  left: 15px;\n  right: auto;\n}\n::ng-deep body app-side-nav nav.menu-collapsed header a.toggle-menu-collapse .icon {\n  transform: rotate(180deg);\n}\n::ng-deep body.rtl app-side-nav nav.menu-collapsed header a.toggle-menu-collapse {\n  left: auto;\n  right: 15px;\n}\n::ng-deep body.rtl app-side-nav nav.menu-collapsed header a.toggle-menu-collapse .icon {\n  transform: rotate(0deg);\n}\n::ng-deep body app-side-nav a.menu-item .menu-item-icon {\n  float: left;\n}\n::ng-deep body.rtl app-side-nav a.menu-item .menu-item-icon {\n  float: right;\n}\n::ng-deep body app-side-nav a.menu-item .menu-item-title {\n  padding-right: 0px;\n  padding-left: 10px;\n  float: left;\n}\n::ng-deep body.rtl app-side-nav a.menu-item .menu-item-title {\n  padding-right: 10px;\n  padding-left: 0px;\n  float: right;\n}\n::ng-deep body app-side-nav a.menu-item .menu-item-expand {\n  left: 196px;\n  right: auto;\n}\n::ng-deep body.rtl app-side-nav a.menu-item .menu-item-expand {\n  left: auto;\n  right: 196px;\n}\n::ng-deep body app-side-nav a.sub-menu-item {\n  padding-right: 0px;\n  padding-left: 50px;\n}\n::ng-deep body.rtl app-side-nav a.sub-menu-item {\n  padding-right: 50px;\n  padding-left: 0px;\n}\n\n.menu-items:focus {\n  outline: none;\n}\n\n.menu-items > ul > li > a {\n  border: 1px dotted transparent;\n}\n\n.keyboard-triggered .menu-items:focus > ul > li[aria-selected=true] > a {\n  border: 1px dotted white;\n}\n\n.keyboard-triggered .menu-items:focus li li[aria-selected=true] span {\n  outline: 1px dotted white;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
